@if ({ activeIndex: activeTabIndex$ | async }; as obj) {
  <div class="mb-8 flex items-center justify-between">
    <h1 class="flex h-11 items-center text-2xl font-bold text-aux-gray-darkest">Design System</h1>
    <div class="flex space-x-2">
      <ng-container [ngTemplateOutlet]="rightSideContainer | async" />
    </div>
  </div>
  <div>
    <div class="mb-8">
      <aux-route-tab-group [tabs]="tabs" />
    </div>

    <router-outlet />
  </div>
}
